<div class="container">
  <mic-breadcrumb id="casing-credit-repair-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('CasingCreditRepairText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="casing-credit-header">
    <h2 class="page-title casing-credit-heading" id="casing-repair-heading">
      {{ translationService.translate('CasingCreditRepairText') }}
    </h2>
    <div class="action-bar">
      <button
        id="reset-filters"
        type="button"
        mat-flat-button
        color="accent"
        class="btn-clear casing-credit-action-button"
        (click)="resetFilters()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearFiltersText') }}
      </button>
      <button
        id="create-casing-repair"
        type="button"
        mat-flat-button
        color="primary"
        class="btn-primary casing-credit-action-button"
        (click)="createCasingRepair()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.translate('createButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="casing-credit-filter-card">
    <form [formGroup]="formGroup">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="codes"
          formControlName="codes"
          [data]="codes"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('SearchByRepairCodeText') }}"
          label="{{ translationService.translate('codeText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="descriptions"
          formControlName="descriptions"
          [data]="descriptions"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('SearchByDescriptionText') }}"
          label="{{ translationService.translate('descriptionText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          [multiple]="true"
        >
        </mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="casing-repair-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table appCopyOnSelect class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'action'">
          <div class="centered-cell">
            <button
              mat-icon-button
              class="btn-delete"
              [disabled]="isDeletable(item)"
              [attr.aria-label]="translationService.translate('deleteText')"
              (click)="showDeleteModal(item)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </ng-container>
      </mic-table>
    </div>
    <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
    <ng-template #deleteContent>{{ translationService.translate('deleteCasingCreditConfirmText') }}</ng-template>
  </div>
</div>
